import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.isInCart
    ? _c(
        VBtn,
        {
          staticClass: "pa-0 elevation-0",
          attrs: {
            "data-qa": "analysis_cart_button",
            "min-width": "40px",
            height: "40px",
            color: "primary",
            disabled: _vm.disableCartButton,
          },
          on: {
            click: function ($event) {
              return _setup.emit("click:add")
            },
          },
        },
        [_c(VIcon, [_vm._v("\n    ui-icon-cart\n  ")])],
        1
      )
    : _vm.isTrashbinButton
    ? _c(
        VBtn,
        {
          staticClass: "pa-0",
          attrs: {
            "data-qa": "analysis_trashbin_button",
            "min-width": "40px",
            height: "40px",
            disabled: _vm.disableCartButton,
            text: "",
          },
          on: {
            click: function ($event) {
              return _setup.emit("click:delete")
            },
          },
        },
        [
          _c(VIcon, { attrs: { size: "24", color: "text-info" } }, [
            _vm._v("\n    ui-icon-trash\n  "),
          ]),
        ],
        1
      )
    : _c(
        VBtn,
        {
          attrs: {
            "data-qa": "analysis_cart_link_button",
            color: "primary",
            text: "",
            href: _vm.cartContentLink,
          },
        },
        [_vm._v("\n  В корзине\n")]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }